<template>
  <div id="app">
    <Menu>
    <router-view/>
    </Menu>
  </div>
</template>

<script>
import Menu from "./components/menu/Menu.vue"
//import Home from "./pages/home/Home.vue"

export default {
  name: 'App',
  components: {
    Menu
    //Home
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #012A56;
  margin-top: 60px;
}
</style>
